export default "__VITE_ASSET__nPekPUi0__"